import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { importWithChunkReload } from '@/shared/lib/chunk-load-recovery'
import { PayrollPermissions } from '@/features/payroll/permissions'

async function lazyGuardedRoute(
  importPage: () => Promise<Record<string, ComponentType>>,
  exportName: string,
): Promise<{ Component: ComponentType }> {
  const mod = await importWithChunkReload(importPage)
  const Page = mod[exportName]
  if (!Page) {
    throw new Error(`Boss route page export "${exportName}" not found`)
  }
  return {
    Component: createPermissionGuardedPage(PayrollPermissions.adminConsoleAccess, Page, {
      mode: 'all',
      administratorBypass: true,
    }),
  }
}

export const bossRoutes: RouteObject[] = [
  {
    path: 'overview',
    lazy: () =>
      lazyGuardedRoute(() => import('./pages/boss-dashboard-page'), 'BossDashboardPage'),
  },
  {
    path: 'overview/payrolls',
    lazy: () =>
      lazyGuardedRoute(() => import('./pages/boss-payrolls-page'), 'BossPayrollsPage'),
  },
  {
    path: 'overview/attendance',
    lazy: () =>
      lazyGuardedRoute(() => import('./pages/boss-attendance-page'), 'BossAttendancePage'),
  },
]
